export const FF_AGENT = 'ff-agent'
export const OPERATOR_AGENT = 'operator-agent'
